// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { OptionsSelector } from '@shared/ui-kit/components/options-selector';
import { type FC, useCallback, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '@advisor-app/store/store';
import { AccountCurrency } from '@shared/data-access/types/brokerage-types';
import { selectAccountCurrency, userSlice } from '@shared/data-access/slices/user';

export const SwitchCurrency: FC = () => {
  const dispatch = useAppDispatch();

  const currencies: AccountCurrency[] = useMemo(
    () => [AccountCurrency.USD, AccountCurrency.EUR],
    [],
  );

  const accountCurrency = useAppSelector(selectAccountCurrency);

  const onSetCurrency = useCallback(
    (currency: AccountCurrency) => {
      if (currency !== accountCurrency) {
        dispatch(userSlice.actions.setCurrency(currency));
      }
    },
    [dispatch, accountCurrency],
  );

  return (
    <div>
      <OptionsSelector
        optionsAvailable={currencies}
        onChangeValueSelected={onSetCurrency}
        defaultText="Select currency"
        selectType="white"
        optionSelected={accountCurrency}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom',
        }}
        defaultValue={AccountCurrency.EUR}
        dataTestId="switch-currency-selector"
      />
    </div>
  );
};
